import api from '../../../api/analyses/activations'
import scheduler_api from '../../../api/analyses/scheduler'
import analyses from "../../../mixin/analyses";

export const fetchAnalysisTypes = ({ commit }) => {
    commit('SET_FIELD_LOADING_STATUS', {field: 'analysis_type_0', status: true})
    commit('SET_FIELD_LOADING_STATUS', {field: 'analysis_type_1', status: true})
    api.getAnalysisTypes()
        .then(res => {
            let data = res.data
            commit('SET_ANALYSIS_TYPES', {
                dataset: 0,
                value: data
            })

            let second_data = []

            data.forEach(function (item) {
                if (!["Anonymized"].includes(item.value)) {
                    second_data.push(item)
                }
            })
            commit('SET_ANALYSIS_TYPES', {
                dataset: 1,
                value: second_data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: 'analysis_type_0', status: false})
            commit('SET_FIELD_LOADING_STATUS', {field: 'analysis_type_1', status: false})
        })
}

export const fetchCohorts = ({ commit, getters }, dataSetOrder) => {
    let field_name = 'cohorts_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getCohorts()
        .then(res => {
            commit('SET_DATASET_COHORTS_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_COHORTS_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchAppsCategories = ({ commit }, dataSetOrder) => {
    let field_name = 'apps_categories_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getAppsCategories()
        .then(res => {
            commit('SET_DATASET_APPS_CATEGORIES_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_APPS_CATEGORIES_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchAppsTags = ({ commit }, dataSetOrder) => {
    let field_name = 'apps_tags_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getAppsTags()
        .then(res => {
            commit('SET_DATASET_APPS_TAGS_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_APPS_TAGS_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchAppsTagsByCategories = ({ commit, getters }, dataSetOrder) => {
    let field_name = 'apps_tags_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getAppsTagsByCategories({
        categories: getters['getAppsCategoriesSelected'](dataSetOrder)
    })
        .then(res => {
            commit('SET_DATASET_APPS_TAGS_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_APPS_TAGS_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchAnonymizedFieldsData = ({ commit, getters }, dataSetOrder) => {
    let field_name = 'anonymized_fields_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getAnonymizedComponentData()
        .then(res => {
            commit('SET_ANONYMIZED_FIELDS', {
                dataset: dataSetOrder,
                value: res.data
            })

            for (const [key, item] of Object.entries(res.data)) {
                let input_data = []
                // let default_selection = []

                for(const [key_item, item_value] of Object.entries(item.fields)) {
                    input_data.push({
                        text: item_value.name,
                        value: item_value.field
                    })

                    // if (item_value.is_default) {
                    //     if (item.is_multi_select) {
                    //         default_selection.push(item_value.field)
                    //     } else {
                    //         default_selection = item_value.field
                    //     }
                    // }
                }
                commit('SET_DATASET_ANONYMIZED_DATA_ALL', {
                    dataset: dataSetOrder,
                    field: key,
                    value: input_data
                })

                commit('SET_DATASET_ANONYMIZED_DATA_COPY', {
                    dataset: dataSetOrder,
                    field: key,
                    value: input_data
                })

                // commit('SET_DATASET_ANONYMIZED_DATA', {
                //     dataset: dataSetOrder,
                //     field: key,
                //     value: default_selection
                // })
            }

            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchAppsOs = ({ commit }, dataSetOrder) => {
    let field_name = 'apps_os_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getAppsOs()
        .then(res => {
            commit('SET_DATASET_APPS_OS_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_APPS_OS_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchAppsNames = ({ commit, getters }, dataSetOrder) => {
    let field_name = 'apps_names_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getAppsNames({
        categories: getters['getAppsCategoriesSelected'](dataSetOrder),
        tags: getters['getAppsTagsSelected'](dataSetOrder)
    })
        .then(res => {
            commit('SET_DATASET_APPS_NAMES_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_APPS_NAMES_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchAppsBundleids = ({ commit, getters }, dataSetOrder) => {
    commit('SET_FIELD_LOADING_STATUS', {field: 'apps_bundleids_' + dataSetOrder, status: true})
    api.getAppsBundleIds({
        categories: getters['getAppsCategoriesSelected'](dataSetOrder),
        tags: getters['getAppsTagsSelected'](dataSetOrder)
    })
        .then(res => {
            commit('SET_DATASET_APPS_BUNDLEIDS_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_APPS_BUNDLEIDS_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: 'apps_bundleids_' + dataSetOrder, status: false})
        })
}

export const fetchSignalProviders = ({ commit, getters }, dataSetOrder) => {
    let field_name = 'signal_providers_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getSignalProviders({
        type: getters['getAnalysisType'](dataSetOrder)
    })
        .then(res => {
            commit('SET_DATASET_SIGNAL_PROVIDERS_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_SIGNAL_PROVIDERS_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchCategories = ({ commit }, {dataSetOrder, analysisType}) => {
    let field_name = 'categories_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getCategories()
        .then(res => {
            if (dataSetOrder.toString().startsWith('comp')) {
                let comp_dataset_id = dataSetOrder.split("_")[1];
                commit('SET_DATASET_COMPETITORS_CATEGORIES_ALL', {
                    dataset: comp_dataset_id,
                    value: res.data
                })

                commit('SET_DATASET_COMPETITORS_CATEGORIES_COPY', {
                    dataset: comp_dataset_id,
                    value: res.data
                })
            } else if (analysisType === 'Cross') {
                commit('SET_DATASET_CATEGORIES_ALL', {
                    dataset: dataSetOrder,
                    value: res.data
                })
                commit('SET_DATASET_CATEGORIES_COPY', {
                    dataset: dataSetOrder,
                    value: res.data
                })
            }
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchBrandsByCategories = ({ commit, getters }, {dataSetOrder, analysisType}) => {
    let field_name = 'brands_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getAnalysisDataByCategory({
        analysisType: "POI",
        categories: getters['getCategoriesSelected'](dataSetOrder)
    })
        .then(res => {
            if (dataSetOrder.toString().startsWith('comp')) {
                let comp_dataset_id = dataSetOrder.split("_")[1];
                commit('SET_DATASET_COMPETITORS_BRANDS_ALL', {
                    dataset: comp_dataset_id,
                    value: res.data
                })

                commit('SET_DATASET_COMPETITORS_BRANDS_COPY', {
                    dataset: comp_dataset_id,
                    value: res.data
                })
            } else if (analysisType === 'Cross') {
                commit('SET_DATASET_BRANDS_ALL', {
                    dataset: dataSetOrder,
                    value: res.data
                })

                commit('SET_DATASET_BRANDS_COPY', {
                    dataset: dataSetOrder,
                    value: res.data
                })
            }
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchCountries = ({commit, getters}, dataSetOrder) => {
    let field_name = 'countries_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getCountries()
        .then(res => {
            commit('SET_DATASET_COUNTRIES_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_COUNTRIES_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchLocationsByBrands = ({commit, getters}, dataSetOrder) => {
    let field_name = 'locations_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getLocationsByBrands({
        brands: getters['getBrandsSelected'](dataSetOrder)
    })
        .then(res => {
            commit('SET_DATASET_LOCATIONS_ALL', {
                dataset: dataSetOrder,
                value: res.data.data
            })
            commit('SET_DATASET_LOCATIONS_COPY', {
                dataset: dataSetOrder,
                value: res.data.data
            })
            commit('SET_DATASET_LOCATIONS_ALL_IDS', {
                dataset: dataSetOrder,
                value: res.data.data.ids
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchCountriesByBrands = ({commit, getters}, dataSetOrder) => {
    let field_name = 'countries_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getCountriesBySelectedData({
        analysisData: getters['getBrandsSelected'](dataSetOrder),
    })
        .then(res => {
            commit('SET_DATASET_COUNTRIES_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_COUNTRIES_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchCountriesByLocations = ({commit, getters}, dataSetOrder) => {
    let field_name = 'countries_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getCountriesBySelectedLocations({
        locations: getters['getLocationsSelected'](dataSetOrder)
    })
        .then(res => {
            commit('SET_DATASET_COUNTRIES_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_COUNTRIES_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchStatesByCountries = ({commit, getters}, dataSetOrder) => {
    let field_name = 'states_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getStatesByCountries({
        countries: getters['getCountriesSelected'](dataSetOrder),
    })
        .then(res => {
            commit('SET_DATASET_STATES_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_STATES_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchDmas = ({ commit, getters}, dataSetOrder) => {
    let field_name = 'dmas_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getDmas()
        .then(res => {
            commit('SET_DATASET_DMAS_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_DMAS_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchDataByCountries = ({ commit, getters}, dataSetOrder) => {
    let field_name = 'brands_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getDataBySelectedCountries({
        countries: getters['getCountriesSelected'](dataSetOrder),
        analysisType: "POI",
        categories: getters['getCategoriesSelected'](dataSetOrder),
    })
        .then(res => {
            commit('SET_DATASET_BRANDS_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_BRANDS_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchCitiesByStates = ({ commit, getters}, dataSetOrder) => {
    let field_name = 'cities_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getCitiesByStates({
        states: getters['getStatesSelected'](dataSetOrder),
    })
        .then(res => {
            commit('SET_DATASET_CITIES_ALL', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_DATASET_CITIES_COPY', {
                dataset: dataSetOrder,
                value: res.data
            })
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchEditingScheduler = ({ commit, getters, rootGetters, dispatch }, scheduler_id) => {
    commit('SET_FIELD_LOADING_STATUS', {field: 'scheduler_edit_fields', status: true})
    scheduler_api.getSingleScheduler({
        scheduler: scheduler_id
    })
        .then(res => {
            commit('SET_NAME', res.data.scheduler.name)

            let start_date = res.data.scheduler.recurrences.start.substring(0, 10)
            let time = res.data.scheduler.recurrences.start.substring(11, 16)
            let full_time = res.data.scheduler.recurrences.start
            commit('SET_SCHEDULER_START_DATE', start_date)
            commit('SET_SCHEDULER_TIME', time)
            commit('SET_SCHEDULER_FULL_TIME', full_time)

            commit('SET_SCHEDULER_MESSAGE', "Scheduled Audience run on " + full_time + " will be canceled.")

            commit('SET_SCHEDULER_ACTIVATION_FREQUENCY', res.data.scheduler.recurrences.frequency)
            commit('SET_SCHEDULER_RECURRENCE_TYPE', res.data.scheduler.recurrences.recurrence_type_id)

            commit('SET_SCHEDULER_PERIOD', res.data.scheduler.recurrences.period_int)
            commit('SET_SCHEDULER_ENDING_TYPE', res.data.scheduler.recurrences.ending_type)

            if (res.data.scheduler.recurrences.ending_type === 2) {
                commit('SET_SCHEDULER_ENDING_RECURRENCES', Number(res.data.scheduler.recurrences.ending_data))

            } else if (res.data.scheduler.recurrences.ending_type === 3) {
                commit('SET_SCHEDULER_END_DATE', res.data.scheduler.recurrences.ending_data)
            }

            commit('SET_FIELD_LOADING_STATUS', {field: 'scheduler_edit_fields', status: false})
        })
}

export const fetchCloningAudience = ({ commit, getters, rootGetters, dispatch }, audience_id) => {
    api.getSingleCloneAudience({
        audience: audience_id
    })
        .then(res => {
            if (res.data.activation.message) {
                commit('SET_MESSAGE', res.data.activation.message)
            }

            commit('SET_NAME', res.data.activation.name)

            for (let i = 0; i < res.data.activation.dataset.length; i++) {
                commit('SET_ANALYSIS_TYPE', {
                    dataset: i,
                    value: res.data.activation.dataset[i].analysistype
                })
                commit('SET_DATASET_SIGNAL_PROVIDERS', {
                    dataset: i,
                    value: res.data.activation.dataset[i].signalproviders
                })
                commit('SET_DATASET_CATEGORIES', {
                    dataset: i,
                    value: res.data.activation.dataset[i].categories
                })
                commit('SET_DATASET_BRANDS', {
                    dataset: i,
                    value: res.data.activation.dataset[i].analysisdata
                })
                commit('SET_DATASET_LOCATIONS', {
                    dataset: i,
                    value: res.data.activation.dataset[i].locations
                })
                commit('SET_DATASET_COUNTRIES', {
                    dataset: i,
                    value: res.data.activation.dataset[i].countries
                })
                commit('SET_DATASET_STATES', {
                    dataset: i,
                    value: res.data.activation.dataset[i].states
                })
                commit('SET_DATASET_DMAS', {
                    dataset: i,
                    value: res.data.activation.dataset[i].dmas
                })
                commit('SET_DATASET_CITIES', {
                    dataset: i,
                    value: res.data.activation.dataset[i].cities
                })

                if (res.data.activation.dataset[i].startDate) {
                    let date = new Date(res.data.activation.dataset[i].startDate + ' UTC');
                    commit('SET_RECENCY_START', {
                        dataset: i,
                        value: date.toJSON().slice(0, 10)
                    })
                }

                if (res.data.activation.dataset[i].endDate) {
                    let date = new Date(res.data.activation.dataset[i].endDate + ' UTC');
                    commit('SET_RECENCY_END', {
                        dataset: i,
                        value: date.toJSON().slice(0, 10)
                    })
                }

                if (['POI', 'Competitors'].includes(res.data.activation.dataset[i].analysistype) && res.data.activation.dataset[i].limits) {
                    dispatch('fetchCountries', i)
                    dispatch('fetchDataByCountries', i)
                    dispatch('fetchLocationsByBrands', i)


                    if ((res.data.activation.dataset[i].limits.time && res.data.activation.dataset[i].limits.time.process) || (res.data.activation.dataset[i].limits.distance && res.data.activation.dataset[i].limits.distance.process)) {
                        commit('SET_LIMITS_STATUS', {
                            dataset: i,
                            value: true
                        })

                        if (res.data.activation.dataset[i].limits.time && res.data.activation.dataset[i].limits.time.process) {
                            commit('SET_LIMITS_TIME_STATUS', {
                                dataset: i,
                                value: true
                            })

                            commit('SET_LIMITS_TIME', {
                                dataset: i,
                                value: [
                                    res.data.activation.dataset[i].limits.time.start,
                                    res.data.activation.dataset[i].limits.time.end
                                ]
                            })
                        }

                        if (res.data.activation.dataset[i].limits.distance && res.data.activation.dataset[i].limits.distance.process) {
                            commit('SET_LIMITS_DISTANCE_STATUS', {
                                dataset: i,
                                value: true
                            })
                            commit('SET_LIMITS_DISTANCE', {
                                dataset: i,
                                value: res.data.activation.dataset[i].limits.distance.distance
                            })
                            commit('SET_LIMITS_DISTANCE_UNIT', {
                                dataset: i,
                                value: res.data.activation.dataset[i].limits.distance.unit
                            })
                        }
                    }
                }

                if (res.data.activation.dataset[i].analysistype === 'Cohorts') {
                    commit('SET_DATASET_COHORT', {
                        dataset: i,
                        value: res.data.activation.dataset[i].cohorts
                    })
                }

                if (res.data.activation.dataset[i].analysistype === 'Competitors') {
                    commit('SET_DATASET_COMPETITORS_CATEGORIES_SELECTED', {
                        dataset: i,
                        value: res.data.activation.dataset[i].competitors.categories
                    })
                    commit('SET_DATASET_COMPETITORS_BRANDS_SELECTED', {
                        dataset: i,
                        value: res.data.activation.dataset[i].competitors.analysisdata
                    })

                    commit('SET_DATASET_COMPETITORS_DISTANCE', {
                        dataset: i,
                        value: res.data.activation.dataset[i].competitors.distance
                    })
                    commit('SET_DATASET_COMPETITORS_UNIT', {
                        dataset: i,
                        value: res.data.activation.dataset[i].competitors.unit
                    })
                }

                if (res.data.activation.dataset[i].analysistype === 'Apps') {
                    commit('SET_DATASET_APPS_CATEGORIES', {
                        dataset: i,
                        value: res.data.activation.dataset[i].apps_categories
                    })
                    commit('SET_DATASET_APPS_TAGS', {
                        dataset: i,
                        value: res.data.activation.dataset[i].apps_tags
                    })
                    commit('SET_DATASET_APPS_BUNDLEIDS', {
                        dataset: i,
                        value: res.data.activation.dataset[i].apps_bundle_ids
                    })
                    commit('SET_DATASET_APPS_OS', {
                        dataset: i,
                        value: res.data.activation.dataset[i].apps_device_os
                    })

                    dispatch('fetchAppsBundleids', i)
                }

                if (res.data.activation.dataset[i].analysistype === 'Anonymized') {
                    if (res.data.activation.dataset[i].selectedFields) {
                        for (const [key, data] of Object.entries(res.data.activation.dataset[i].selectedFields)) {
                            commit('SET_DATASET_ANONYMIZED_DATA', {
                                dataset: i,
                                field: key,
                                value: data
                            })
                        }
                    }
                }

                if (res.data.activation.dataset[i].zipcodes && ['POI', 'Competitors'].includes(res.data.activation.dataset[i].analysistype)) {
                    commit('SET_DATASET_ZIP_CODES', {
                        dataset: i,
                        value: res.data.activation.dataset[i].zipcodes.join("\n")
                    })
                }
            }

            commit('SET_QUERY', res.data.activation.query)

            if (rootGetters.getUserPermissions.includes('feature-activation-analyses-crossvisitation')) {
                commit('SET_ANALYSES_STATUS', {
                    analysis: 'cross_visitation',
                    value: !!res.data.activation.analyses.crossvisitation.process
                })
                commit('SET_ANALYSES_CROSS_VISITATION_POI_LOCATION_LEVEL', !!res.data.activation.analyses.crossvisitation.poi_level)
                commit('SET_DATASET_CATEGORIES', {
                    dataset: 'cross',
                    value: res.data.activation.analyses.crossvisitation.categories ?? []
                })
                commit('SET_DATASET_BRANDS', {
                    dataset: 'cross',
                    value: res.data.activation.analyses.crossvisitation.brands ?? []
                })
                commit('SET_DATASET_LOCATIONS', {
                    dataset: 'cross',
                    value: res.data.activation.analyses.crossvisitation.locations ?? []
                })

                if (res.data.activation.analyses.crossvisitation.location) {
                    commit('SET_DATASET_COUNTRIES', {
                        dataset: 'cross',
                        value: res.data.activation.analyses.crossvisitation.location.countries ?? []
                    })
                    commit('SET_DATASET_STATES', {
                        dataset: 'cross',
                        value: res.data.activation.analyses.crossvisitation.location.states ?? []
                    })
                    commit('SET_DATASET_DMAS', {
                        dataset: 'cross',
                        value: res.data.activation.analyses.crossvisitation.location.dmas ?? []
                    })
                    commit('SET_DATASET_CITIES', {
                        dataset: 'cross',
                        value: res.data.activation.analyses.crossvisitation.location.cities ?? []
                    })

                    dispatch('fetchCountries', 'cross')
                    dispatch('fetchDataByCountries', 'cross')
                    dispatch('fetchLocationsByBrands', 'cross')

                    if (res.data.activation.analyses.crossvisitation.location.zipcodes) {
                        commit('SET_DATASET_ZIP_CODES', {
                            dataset: 'cross',
                            value: res.data.activation.analyses.crossvisitation.location.zipcodes.join("\n")
                        })
                    }
                }

                if (res.data.activation.analyses.crossvisitation.startDate) {
                    let date = new Date(res.data.activation.analyses.crossvisitation.startDate + ' UTC');
                    commit('SET_RECENCY_START', {
                        dataset: 'cross',
                        value: date.toJSON().slice(0, 10)
                    })
                }

                if (res.data.activation.analyses.crossvisitation.endDate) {
                    let date = new Date(res.data.activation.analyses.crossvisitation.endDate + ' UTC');
                    commit('SET_RECENCY_END', {
                        dataset: 'cross',
                        value: date.toJSON().slice(0, 10)
                    })
                }

                if (res.data.activation.analyses.crossvisitation.filters) {
                    let temp_filters = []
                    Object.entries(res.data.activation.analyses.crossvisitation.filters).forEach((filter) => {
                        if (filter[1]) {
                            temp_filters.push(filter[0])
                        }
                    })
                    commit('SET_FILTERS_SELECTED', {
                        dataset: 'cross',
                        value: temp_filters
                    })
                }

                if (res.data.activation.analyses.crossvisitation.limits) {
                    if ((res.data.activation.analyses.crossvisitation.limits.time && res.data.activation.analyses.crossvisitation.limits.time.process) || (res.data.activation.analyses.crossvisitation.limits.distance && res.data.activation.analyses.crossvisitation.limits.distance.process)) {
                        commit('SET_LIMITS_STATUS', {
                            dataset: 'cross',
                            value: true
                        })

                        if (res.data.activation.analyses.crossvisitation.limits.time && res.data.activation.analyses.crossvisitation.limits.time.process) {
                            commit('SET_LIMITS_TIME_STATUS', {
                                dataset: 'cross',
                                value: true
                            })

                            commit('SET_LIMITS_TIME', {
                                dataset: 'cross',
                                value: [
                                    res.data.activation.analyses.crossvisitation.limits.time.start,
                                    res.data.activation.analyses.crossvisitation.limits.time.end
                                ]
                            })
                        }

                        if (res.data.activation.analyses.crossvisitation.limits.distance && res.data.activation.analyses.crossvisitation.limits.distance.process) {
                            commit('SET_LIMITS_DISTANCE_STATUS', {
                                dataset: 'cross',
                                value: true
                            })
                            commit('SET_LIMITS_DISTANCE', {
                                dataset: 'cross',
                                value: res.data.activation.analyses.crossvisitation.limits.distance.distance
                            })
                            commit('SET_LIMITS_DISTANCE_UNIT', {
                                dataset: 'cross',
                                value: res.data.activation.analyses.crossvisitation.limits.distance.unit
                            })
                        }
                    }
                }
            } else {
                commit('SET_ANALYSES_STATUS', {
                    analysis: 'cross_visitation',
                    value: false
                })
            }

            if (rootGetters.getUserPermissions.includes('feature-activation-analyses-frequency')) {
                commit('SET_ANALYSES_STATUS', {
                    analysis: 'frequency',
                    value: !!res.data.activation.analyses.frequency.process
                })
                commit('SET_ANALYSES_FREQUENCY_DAY_PART', !!res.data.activation.analyses.frequency.day_part)
            } else {
                commit('SET_ANALYSES_STATUS', {
                    analysis: 'frequency',
                    value: false
                })
                commit('SET_ANALYSES_FREQUENCY_DAY_PART', false)
            }

            if (rootGetters.getUserPermissions.includes('feature-activation-analyses-distance')) {
                if (res.data.activation.analyses.distance) {
                    commit('SET_ANALYSES_STATUS', {
                        analysis: 'distance',
                        value: !!res.data.activation.analyses.distance.process
                    })
                }
            } else {
                commit('SET_ANALYSES_STATUS', {
                    analysis: 'distance',
                    value: false
                })
            }

            if (res.data.activation.filters) {
                let temp_filters = []
                Object.entries(res.data.activation.filters).forEach((filter) => {
                    if (filter[1]) {
                        temp_filters.push(filter[0])
                    }
                })
                commit('SET_FILTERS_SELECTED', {
                    dataset: 'poi',
                    value: temp_filters
                })
            }
        })
}

export const fetchPoiData = ({commit, getters}, {dataSetOrder, analysisType}) => {
    let field_name_segments = 'cities_' + dataSetOrder
    let field_name_categories = 'categories_' + dataSetOrder
    let field_name_brands = 'brands_' + dataSetOrder
    commit('SET_FIELD_LOADING_STATUS', {field: field_name_segments, status: true})
    commit('SET_FIELD_LOADING_STATUS', {field: field_name_categories, status: true})
    commit('SET_FIELD_LOADING_STATUS', {field: field_name_brands, status: true})

    api.getPoiData({
        type: ['POI', 'Cross', 'Competitors'].includes(analysisType) ? 'POI' : '',
        segments: getters['getSegmentsSelected'](dataSetOrder) || [],
        categories: getters['getCategoriesSelected'](dataSetOrder) || [],
        pois: getters['getBrandsSelected'](dataSetOrder) || []
    })
        .then(res => {
            commit('SET_DATASET_SEGMENTS_ALL', {
                dataset: dataSetOrder,
                value: res.data.segments
            })
            commit('SET_DATASET_SEGMENTS_COPY', {
                dataset: dataSetOrder,
                value: res.data.segments
            })

            commit('SET_DATASET_CATEGORIES_ALL', {
                dataset: dataSetOrder,
                value: res.data.categories
            })
            commit('SET_DATASET_CATEGORIES_COPY', {
                dataset: dataSetOrder,
                value: res.data.categories
            })

            commit('SET_DATASET_BRANDS_ALL', {
                dataset: dataSetOrder,
                value: res.data.pois
            })
            commit('SET_DATASET_BRANDS_COPY', {
                dataset: dataSetOrder,
                value: res.data.pois
            })

            commit('SET_FIELD_LOADING_STATUS', {field: field_name_segments, status: false})
            commit('SET_FIELD_LOADING_STATUS', {field: field_name_categories, status: false})
            commit('SET_FIELD_LOADING_STATUS', {field: field_name_brands, status: false})
        })
}

export const mergeLocationIds = ({ commit, getters }, datasetOrder) => {
    if (getters['getLocationsInsertCustomStatus'](datasetOrder) && getters['getLocationsCustomIds'](datasetOrder) !== '') {
        let locationIds = getters['getLocationsCustomIds'](datasetOrder).split("\n").map( Number )
        commit('SET_DATASET_LOCATIONS_CONCATENATED', {
            dataset: datasetOrder,
            value: [...new Set(getters['getLocationsSelected'](datasetOrder).concat(locationIds))]
        })
    } else {
        commit('SET_DATASET_LOCATIONS_CONCATENATED', {
            dataset: datasetOrder,
            value: getters['getLocationsSelected'](datasetOrder)
        })
    }
}

export const mergeBundleIds = ({ commit, getters }, datasetOrder) => {
    if (getters['getAppsBundleidsInsertCustomStatus'](datasetOrder) && getters['getAppsBundleidsCustomIds'](datasetOrder) !== '') {
        let bundleidsIds = getters['getAppsBundleidsCustomIds'](datasetOrder).split("\n").map( String )
        commit('SET_DATASET_APPS_BUNDLEIDS_CONCATENATED', {
            dataset: datasetOrder,
            value: [...new Set(getters['getAppsBundleidsSelected'](datasetOrder).concat(bundleidsIds))]
        })
    } else {
        commit('SET_DATASET_APPS_BUNDLEIDS_CONCATENATED', {
            dataset: datasetOrder,
            value: getters['getAppsBundleidsSelected'](datasetOrder)
        })
    }
}

export const createNewAudience = ({ commit, getters }) => {
    api.createNewActivation({
        description: getters.getActivationName,
        query: getters.getQuery,
        crossvisitation_process: getters.getAnalysesCrossVisitationStatus,
        poi_location_level: getters.getAnalysesCrossVisitationPoiLocationLevel,
        frequency_process: getters.getAnalysesFrequencyStatus,
        frequency_day_part: getters.getAnalysesFrequencyIsDayPart,
        distance_process: getters.getAnalysesDistanceStatus,
        analysistype_0: getters.getAnalysisType(0),
        signalproviders_0: getters.getSignalProvidersSelected(0),
        categories_0: getters.getCategoriesSelected(0),
        analysisdata_0: getters.getBrandsSelected(0),
        locations_0: getters.getLocationsConcatenated(0),
        apps_categories_0: getters.getAppsCategoriesSelected(0),
        apps_tags_0: getters.getAppsTagsSelected(0),
        apps_bundle_ids_0: getters.getAppsBundleidsConcatenated(0),
        apps_device_os_0: getters.getAppsOsSelected(0),
        countries_0: getters.getCountriesSelected(0),
        states_0: getters.getStatesSelected(0),
        cities_0: getters.getCitiesSelected(0),
        dmas_0: getters.getDmasSelected(0),
        cohorts_0: getters.getCohortsSelected(0),
        zip_codes_0: getters.getZipCodes(0),
        categories_comp_0: getters.getCategoriesSelected('comp_0'),
        analysis_data_comp_0: getters.getBrandsSelected('comp_0'),
        distance_comp_0: getters.getLimitsDistance('comp_0'),
        unit_comp_0: getters.getLimitsDistanceUnit('comp_0'),
        start_date_0: getters.getRecencyStart(0) === '' ? null : getters.getRecencyStart(0),
        end_date_0: getters.getRecencyEnd(0) === '' ? null : getters.getRecencyEnd(0),
        limits_0: getters.getLimitsStatus(0),
        time_limits_process_0: getters.getLimitsTimeStatus(0),
        time_limits_0: getters.getLimitsTime(0),
        distance_limits_process_0: getters.getLimitsDistanceStatus(0),
        distance_limits_unit_0: getters.getLimitsDistanceUnit(0),
        distance_limits_0: getters.getLimitsDistance(0),
        filters_poi: getters.getFiltersSelected('poi'),
        anonymized_0: {
            is_selected: [getters.getAnalysisType(0)].includes('Anonymized'),
            fields: {
                geoLocation: getters.getAnonymizedData({dataset: 0, item: 'geoLocation'}),
                advertising: getters.getAnonymizedData({dataset: 0, item: 'advertising'}),
                userDetails: getters.getAnonymizedData({dataset: 0, item: 'userDetails'}),
                ipDetails: getters.getAnonymizedData({dataset: 0, item: 'ipDetails'}),
                privacy: getters.getAnonymizedData({dataset: 0, item: 'privacy'}),
            }
        },
        analysistype_1: getters.getAnalysisType(1),
        signalproviders_1: getters.getSignalProvidersSelected(1),
        categories_1: getters.getCategoriesSelected(1),
        analysisdata_1: getters.getBrandsSelected(1),
        locations_1: getters.getLocationsConcatenated(1),
        apps_categories_1: getters.getAppsCategoriesSelected(1),
        apps_tags_1: getters.getAppsTagsSelected(1),
        apps_bundle_ids_1: getters.getAppsBundleidsConcatenated(1),
        apps_device_os_1: getters.getAppsOsSelected(1),
        countries_1: getters.getCountriesSelected(1),
        states_1: getters.getStatesSelected(1),
        cities_1: getters.getCitiesSelected(1),
        dmas_1: getters.getDmasSelected(1),
        cohorts_1: getters.getCohortsSelected(1),
        zip_codes_1: getters.getZipCodes(1),
        categories_comp_1: getters.getCategoriesSelected('comp_1'),
        analysis_data_comp_1: getters.getBrandsSelected('comp_1'),
        distance_comp_1: getters.getLimitsDistance('comp_1'),
        unit_comp_1: getters.getLimitsDistanceUnit('comp_1'),
        start_date_1: getters.getRecencyStart(1) === '' ? null : getters.getRecencyStart(1),
        end_date_1: getters.getRecencyEnd(1) === '' ? null : getters.getRecencyEnd(1),
        limits_1: getters.getLimitsStatus(1),
        time_limits_process_1: getters.getLimitsTimeStatus(1),
        time_limits_1: getters.getLimitsTime(1),
        distance_limits_process_1: getters.getLimitsDistanceStatus(1),
        distance_limits_unit_1: getters.getLimitsDistanceUnit(1),
        distance_limits_1: getters.getLimitsDistance(1),
        anonymized_1: {
            is_selected: [getters.getAnalysisType(1)].includes('Anonymized'),
            fields: {
                geoLocation: getters.getAnonymizedData({dataset: 1, item: 'geoLocation'}),
                advertising: getters.getAnonymizedData({dataset: 1, item: 'advertising'}),
                userDetails: getters.getAnonymizedData({dataset: 1, item: 'userDetails'}),
                ipDetails: getters.getAnonymizedData({dataset: 1, item: 'ipDetails'}),
                privacy: getters.getAnonymizedData({dataset: 1, item: 'privacy'}),
            }
        },
        categories_cross: getters.getCategoriesSelected('cross'),
        analysisdata_cross: getters.getBrandsSelected('cross'),
        locations_cross: getters.getLocationsConcatenated('cross'),
        countries_cross: getters.getCountriesSelected('cross'),
        states_cross: getters.getStatesSelected('cross'),
        dmas_cross: getters.getDmasSelected('cross'),
        cities_cross: getters.getCitiesSelected('cross'),
        zip_codes_cross: getters.getZipCodes('cross'),
        start_date_cross: getters.getRecencyStart('cross') === '' ? null : getters.getRecencyStart('cross'),
        end_date_cross: getters.getRecencyEnd('cross') === '' ? null : getters.getRecencyEnd('cross'),
        limits_cross: getters.getLimitsStatus('cross'),
        time_limits_process_cross: getters.getLimitsTimeStatus('cross'),
        time_limits_cross: getters.getLimitsTime('cross'),
        distance_limits_process_cross: getters.getLimitsDistanceStatus('cross'),
        distance_limits_unit_cross: getters.getLimitsDistanceUnit('cross'),
        distance_limits_cross: getters.getLimitsDistance('cross'),
        filters_cross: getters.getFiltersSelected('cross'),
        create_cohort: getters.getCreateCohortStatus,
        notification: getters.getNotificationStatus
    })
        .then(res => {
            commit('RESET_STATE')
            commit('SET_MODAL', false)
        })
        .catch(e => {
            commit('RESET_STATE')
            commit('SET_MODAL', false)
        })
}

export const createNewScheduler = ({ commit, getters, rootGetters }) => {
    scheduler_api.createNewSchedule({
        name: getters.getActivationName,
        audience_type: getters.getSchedulerAudienceType,
        audience_id: getters.getSchedulerSelectedAudience,
        query: getters.getQuery,
        crossvisitation_process: getters.getAnalysesCrossVisitationStatus,
        poi_location_level: getters.getAnalysesCrossVisitationPoiLocationLevel,
        frequency_process: getters.getAnalysesFrequencyStatus,
        frequency_day_part: getters.getAnalysesFrequencyIsDayPart,
        distance_process: getters.getLimitsDistanceStatus,
        analysistype_0: getters.getAnalysisType(0),
        signalproviders_0: getters.getSignalProvidersSelected(0),
        categories_0: getters.getCategoriesSelected(0),
        analysisdata_0: getters.getBrandsSelected(0),
        locations_0: getters.getLocationsConcatenated(0),
        apps_categories_0: getters.getAppsCategoriesSelected(0),
        apps_tags_0: getters.getAppsTagsSelected(0),
        apps_bundle_ids_0: getters.getAppsBundleidsConcatenated(0),
        apps_device_os_0: getters.getAppsOsSelected(0),
        countries_0: getters.getCountriesSelected(0),
        states_0: getters.getStatesSelected(0),
        cities_0: getters.getCitiesSelected(0),
        dmas_0: getters.getDmasSelected(0),
        cohorts_0: getters.getCohortsSelected(0),
        zip_codes_0: getters.getZipCodes(0),

        categories_comp_0: getters.getCategoriesSelected('comp_0'),
        analysis_data_comp_0: getters.getBrandsSelected('comp_0'),
        distance_comp_0: getters.getLimitsDistance('comp_0'),
        unit_comp_0: getters.getLimitsDistanceUnit('comp_0'),

        limits_0: getters.getLimitsStatus(0),
        time_limits_process_0: getters.getLimitsTimeStatus(0),
        time_limits_0: getters.getLimitsTime(0),
        distance_limits_process_0: getters.getLimitsDistanceStatus(0),
        distance_limits_unit_0: getters.getLimitsDistanceUnit(0),
        distance_limits_0: getters.getLimitsDistance(0),
        filters_poi: getters.getFiltersSelected('poi'),

        anonymized_0: {
            is_selected: [getters.getAnalysisType(0)].includes('Anonymized'),
            fields: {
                geoLocation: getters.getAnonymizedData({dataset: 0, item: 'geoLocation'}),
                advertising: getters.getAnonymizedData({dataset: 0, item: 'advertising'}),
                userDetails: getters.getAnonymizedData({dataset: 0, item: 'userDetails'}),
                ipDetails: getters.getAnonymizedData({dataset: 0, item: 'ipDetails'}),
                privacy: getters.getAnonymizedData({dataset: 0, item: 'privacy'}),
            }
        },

        analysistype_1: getters.getAnalysisType(1),
        signalproviders_1: getters.getSignalProvidersSelected(1),
        categories_1: getters.getCategoriesSelected(1),
        analysisdata_1: getters.getBrandsSelected(1),
        locations_1: getters.getLocationsConcatenated(1),
        apps_categories_1: getters.getAppsCategoriesSelected(1),
        apps_tags_1: getters.getAppsTagsSelected(1),
        apps_bundle_ids_1: getters.getAppsBundleidsConcatenated(1),
        apps_device_os_1: getters.getAppsOsSelected(1),
        countries_1: getters.getCountriesSelected(1),
        states_1: getters.getStatesSelected(1),
        cities_1: getters.getCitiesSelected(1),
        dmas_1: getters.getDmasSelected(1),
        cohorts_1: getters.getCohortsSelected(1),
        zip_codes_1: getters.getZipCodes(1),

        categories_comp_1: getters.getCategoriesSelected('comp_1'),
        analysis_data_comp_1: getters.getBrandsSelected('comp_1'),
        distance_comp_1: getters.getLimitsDistance('comp_1'),
        unit_comp_1: getters.getLimitsDistanceUnit('comp_1'),

        limits_1: getters.getLimitsStatus(1),
        time_limits_process_1: getters.getLimitsTimeStatus(1),
        time_limits_1: getters.getLimitsTime(1),
        distance_limits_process_1: getters.getLimitsDistanceStatus(1),
        distance_limits_unit_1: getters.getLimitsDistanceUnit(1),
        distance_limits_1: getters.getLimitsDistance(1),

        anonymized_1: {
            is_selected: [getters.getAnalysisType(1)].includes('Anonymized'),
            fields: {
                geoLocation: getters.getAnonymizedData({dataset: 1, item: 'geoLocation'}),
                advertising: getters.getAnonymizedData({dataset: 1, item: 'advertising'}),
                userDetails: getters.getAnonymizedData({dataset: 1, item: 'userDetails'}),
                ipDetails: getters.getAnonymizedData({dataset: 1, item: 'ipDetails'}),
                privacy: getters.getAnonymizedData({dataset: 1, item: 'privacy'}),
            }
        },

        categories_cross: getters.getCategoriesSelected('cross'),
        analysisdata_cross: getters.getBrandsSelected('cross'),
        locations_cross: getters.getLocationsConcatenated('cross'),
        countries_cross: getters.getCountriesSelected('cross'),
        states_cross: getters.getStatesSelected('cross'),
        dmas_cross: getters.getDmasSelected('cross'),
        cities_cross: getters.getCitiesSelected('cross'),
        zip_codes_cross: getters.getZipCodes('cross'),
        limits_cross: getters.getLimitsStatus('cross'),
        time_limits_process_cross: getters.getLimitsTimeStatus('cross'),
        time_limits_cross: getters.getLimitsTime('cross'),
        distance_limits_process_cross: getters.getLimitsDistanceStatus('cross'),
        distance_limits_unit_cross: getters.getLimitsDistanceUnit('cross'),
        distance_limits_cross: getters.getLimitsDistance('cross'),
        filters_cross: getters.getFiltersSelected('cross'),

        startDate: getters.getSchedulerStartDate,
        fullTime: getters.getSchedulerFullTime,
        frequency: getters.getSchedulerActivationFrequency,
        recurrence_type: getters.getSchedulerRecurrenceType,
        period: getters.getSchedulerPeriod,

        ending_type: getters.getSchedulerEndingType,
        after_recurrences: getters.getSchedulerEndingRecurrences,
        endDate: getters.getSchedulerEndDate,

        activation: getters.getSchedulerAutoActivateStatus,
        datastreams: rootGetters['ActivateAudienceStore/getDataStreamsDeliveryData'],
        credentials: rootGetters['ActivateAudienceStore/getAudienceServiceAccount'],
        limit: rootGetters['ActivateAudienceStore/getAudience'],
        inputs: rootGetters['ActivateAudienceStore/getActivationPartner'].inputs,
        audience_inputs: rootGetters['ActivateAudienceStore/getAudienceInputs'],
        partner_name: rootGetters['ActivateAudienceStore/getActivationPartner'].name,
        pricing_model: rootGetters['ActivateAudienceStore/getPricingModel'],
        price: rootGetters['ActivateAudienceStore/getPrice'],
        compression: rootGetters['ActivateAudienceStore/getAudienceCompressionType'],
        timezone: getters.getSchedulerTimeZone,

        create_cohort: getters.getCreateCohortStatus,
        notification: getters.getNotificationStatus,
    })
        .then(res => {
            commit('SET_SCHEDULER_MODAL', false)
            commit('RESET_STATE')
            commit('ActivateAudienceStore/RESET_STATE', true, { root: true })

            window.location.href = '/data-explorer/analyses/scheduler'
        })
        .catch(e => {
            commit('SET_SCHEDULER_MODAL', false)
            commit('RESET_STATE')
            commit('ActivateAudienceStore/RESET_STATE', true, { root: true })

            window.location.href = '/data-explorer/analyses/scheduler'
        })
}

export const updateScheduler = ({ commit, getters }) => {
    scheduler_api.updateSchedule({
        scheduler_id: getters.getSchedulerEditingId,
        name: getters.getActivationName,

        startDate: getters.getSchedulerStartDate,
        fullTime: getters.getSchedulerFullTime,
        frequency: getters.getSchedulerActivationFrequency,
        recurrence_type: getters.getSchedulerRecurrenceType,
        period: getters.getSchedulerPeriod,

        ending_type: getters.getSchedulerEndingType,
        after_recurrences: getters.getSchedulerEndingRecurrences,
        endDate: getters.getSchedulerEndDate,
    })
        .then(res => {
            commit('SET_SCHEDULER_EDIT_MODAL', false)
            commit('RESET_STATE')
            commit('ActivateAudienceStore/RESET_STATE', true, { root: true })

            window.location.href = '/data-explorer/analyses/scheduler'
        })
        .catch(e => {
            commit('SET_SCHEDULER_EDIT_MODAL', false)
            commit('RESET_STATE')
            commit('ActivateAudienceStore/RESET_STATE', true, { root: true })

            window.location.href = '/data-explorer/analyses/scheduler'
        })
}

export const fetchAudiences = ({ commit }) => {
    let field_name = 'scheduler_audiences'
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    scheduler_api.getAllAudiences()
        .then(res => {
            commit('SET_SCHEDULER_ALL_AUDIENCES', res.data)
            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const fetchAudience = ({ commit, getters }) => {
    let field_name = 'scheduler_audiences'
    commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: true})
    api.getSingleAudience({
        audience: getters['getSchedulerSelectedAudience']
    })
        .then(res => {
            let dataset_types = []

            dataset_types.push(res.data.activation.dataset[0].analysistype.toLowerCase())

            if (res.data.activation.dataset[1]) {
                dataset_types.push(res.data.activation.dataset[1].analysistype.toLowerCase())
            }

            commit('ActivateAudienceStore/SET_ACTIVATION_ANALYSES', dataset_types, { root: true })

            commit('SET_FIELD_LOADING_STATUS', {field: field_name, status: false})
        })
}

export const increaseSchedulerProcessStep = ({ commit, getters }) => {
    let current_step = getters.getSchedulerStep
    let new_step = current_step + 1
    commit('SET_SCHEDULER_STEP', new_step)
}

export const decreaseSchedulerProcessStep = ({ commit, getters }) => {
    let current_step = getters.getSchedulerStep
    let new_step = current_step - 1
    commit('SET_SCHEDULER_STEP', new_step)
}